export enum MedicalProceduresType {
    Default = null,
    Received = 1,
    Completed = 2,
}